(ns frontend.ux-overhaul.listing.kyc.model)

(def root-path [::state])

(def selected-profile-id-key :selected-profile-id)
(def selected-profile-id-full-path (conj root-path selected-profile-id-key))

(def entities-key :entities)
(def entities-full-path (conj root-path entities-key))

(def bulk-edit-open?-key :bulk-edit-open?)
(def bulk-edit-open?-full-path (conj root-path bulk-edit-open?-key))
